const initObjectFitVideo = (videoHolder = '.js-video-holder') => {
    const $win = $(window);
    const $videoBg = $(videoHolder);
    const $videoIframe = $videoBg.find('video');

    if ( $videoBg.length ) {
        $win.on('load resize', function() {
            const $video = $videoBg.find('video');
            const videoEl = $videoIframe[0];

            let videoBgWidth = $videoBg.outerWidth( true );
            let videoBgHeight = $videoBg.outerHeight( true );

            let videoW = videoEl.width;
            let videoH = videoEl.height;
            let videoRatio = ( videoW / videoH ).toFixed(2);

            let widthRatio = (videoBgWidth / videoW).toFixed(2);
            let heightRatio = (videoBgHeight / videoH).toFixed(2);

            let newWidth = widthRatio > heightRatio ? videoBgWidth : Math.ceil( videoBgHeight * videoRatio );
            let newHeight = widthRatio > heightRatio ? Math.ceil( videoBgWidth / videoRatio ) : videoBgHeight;

            $videoIframe.css({
                'width': newWidth,
                'height': newHeight + 2
            });
        });
    }
}

initObjectFitVideo();
